import moment from "moment";
import React from "react";
import { formatTimeDifference, formatDayWithDate } from "utilities";
import { getRealStartEndDate } from "utilities/showDateUtils";

const ShowDateForList = ({ dateTime }: { dateTime: server.dto.AppointmentDateTime }) => {
  const startDisplayMoment = moment.utc(dateTime.startDisplay);
  const endDisplayMoment = moment.utc(dateTime.endDisplay);
  const { startRealDate, endRealDate } = getRealStartEndDate({
    startDisplayDate: startDisplayMoment,
    endDisplayDate: endDisplayMoment,
    timeOfPerformance: dateTime.customFallbackTime,
    mode: dateTime.mode
  });
  const timeDifference = formatTimeDifference(startRealDate, endRealDate);

  const longerThanOneDay = !startDisplayMoment.isSame(endDisplayMoment, "day");

  return <span style={{ whiteSpace: "nowrap" }} title={timeDifference}>
    {formatDayWithDate(startDisplayMoment)}
    {longerThanOneDay && <div className="text-sublabel">
      » {formatDayWithDate(endDisplayMoment)}
    </div>}
  </span>;
};

export default ShowDateForList;